import { createStore } from 'react-sweet-state';
import { cloneDeep } from 'lodash';

import { queryViewSharedDocument } from 'src/graphql/sharing';
import Authentication from 'src/utils/Authentication';
import { getParsedGraphQLFirstError } from 'src/utils/lib/graphql';
import { VIEW_TYPE } from '../../const';

const NAME = 'page-shared-main';

const INITIAL_STATE = {
  activeView: VIEW_TYPE.loading, // "shared" page opens in "loading" state
  shareDocumentId: null,
  projectData: null,
  error: null,
};

export const PRIVATE_ACTIONS = {
  clearStore:
    () =>
    ({ setState }) => {
      setState(cloneDeep(INITIAL_STATE));
    },
};

/**
 * Public available actions
 */
const ACTIONS = {
  loadSharedProject:
    (shareDocumentId) =>
    async ({ setState, dispatch }) => {
      dispatch(PRIVATE_ACTIONS.clearStore());

      setState({
        activeView: VIEW_TYPE.loading,
        shareDocumentId,
      });

      try {
        const result = await queryViewSharedDocument(shareDocumentId);
        const shouldRedirect = result?.editable && Authentication.isAuthenticated();

        setState({
          activeView: shouldRedirect ? VIEW_TYPE.redirecting : VIEW_TYPE.project,
          projectData: result,
        });
      } catch (error) {
        const parsedError = getParsedGraphQLFirstError(error);
        setState({ activeView: VIEW_TYPE.error, error: parsedError });
      }
    },

  getProjectId:
    () =>
    ({ getState }) => {
      const { projectData } = getState();
      return projectData?.id;
    },

  getShareDocumentId:
    () =>
    ({ getState }) => {
      const { shareDocumentId } = getState();
      return shareDocumentId;
    },
};

export const MainStore = createStore({
  initialState: INITIAL_STATE,
  actions: ACTIONS,
  name: NAME,
});
